import React from 'react'
import Spinner from 'react-bootstrap/Spinner'

type FhirLoaderProps = {
    message?: string
    hidden?: boolean
    small?: boolean
}

const FhirLoader: React.FC<FhirLoaderProps> = ({ message = 'Loading...', hidden = false, small = false }) => {
    return (
        <span role="status" aria-live="polite" aria-atomic="true" className="d-flex align-items-center">
            <Spinner
                as="span"
                animation="border"
                aria-hidden="true"
                size={small ? 'sm' : undefined}
            />
            <span className={hidden ? 'visually-hidden ms-2' : 'ms-2'}>{message}</span>
        </span>
    )
}

export default FhirLoader